import {
  formatMonitoringHttp,
  formatMonitoringLatency,
  monitoringGroupLabel,
  monitoringStatusBadge,
} from '@/lib/monitoring-panel'
import type { AdminMonitoringProbe, AdminMonitoringProbeGroup } from '@/types/api'
import styles from './MonitoramentoPage.module.css'

const GROUPS: AdminMonitoringProbeGroup[] = ['infra', 'widget_sale', 'payment', 'auth']

interface MonitoringProbeTableProps {
  probes: AdminMonitoringProbe[]
}

export function MonitoringProbeTable({ probes }: MonitoringProbeTableProps) {
  return (
    <>
      {GROUPS.map((group) => {
        const items = probes.filter((probe) => probe.group === group)
        if (items.length === 0) return null

        return (
          <section key={group} className={styles.section} aria-label={monitoringGroupLabel(group)}>
            <h2 className={styles.sectionTitle}>{monitoringGroupLabel(group)}</h2>
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th scope="col">Sonda</th>
                    <th scope="col">Status</th>
                    <th scope="col">HTTP</th>
                    <th scope="col">Latência</th>
                    <th scope="col">Detalhe</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((probe) => (
                    <tr key={probe.id} data-status={probe.status}>
                      <th scope="row">{probe.label}</th>
                      <td>
                        <span className={styles.badge} data-status={probe.status}>
                          {monitoringStatusBadge(probe.status)}
                        </span>
                      </td>
                      <td className={styles.numeric}>{formatMonitoringHttp(probe.http_status)}</td>
                      <td className={styles.numeric}>{formatMonitoringLatency(probe.latency_ms)}</td>
                      <td>{probe.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        )
      })}
    </>
  )
}
